import React, { useEffect, useState } from "react";
import { C } from "../theme";

const BASE_WAVE = [3, 6, 9, 12, 9, 6, 3, 6, 10, 7, 4];

export default function VoiceWave({ active }) {
  const [heights, setHeights] = useState(BASE_WAVE);

  useEffect(() => {
    if (!active) {
      setHeights(BASE_WAVE);
      return;
    }
    const id = setInterval(() => {
      setHeights(BASE_WAVE.map((b) => b * (0.5 + Math.random())));
    }, 150);
    return () => clearInterval(id);
  }, [active]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 3, height: 24 }}>
      {heights.map((v, i) => (
        <div
          key={i}
          style={{
            width: 3,
            height: v,
            borderRadius: 2,
            background: active ? C.accent : C.muted,
            transition: "height 0.12s ease",
          }}
        />
      ))}
    </div>
  );
}
